/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,400i,600,700);@font-face{font-family:WebComponentsIcons;src:url(/fonts/glyphs/WebComponentsIcons.eot) format(\"embedded-opentype\"),url(/fonts/glyphs/WebComponentsIcons.ttf) format(\"truetype\"),url(/fonts/glyphs/WebComponentsIcons.woff) format(\"woff\"),url(/fonts/glyphs/WebComponentsIcons.svg) format(\"svg\");font-style:normal;font-weight:400}.warningText{color:#c32c2c;font-weight:700}"];
export { styles as styles };
